import ConfirmPaymentForm from '@frontend/features/confirm-payment/ConfirmPaymentForm'
import { usePostBySlug } from '@frontend/libs/hooks/usePost'
import ErrorBoundary from '@shared/ErrorBoundary'
import { useErrorBoundary } from 'react-error-boundary'
import toast from 'react-hot-toast'

function Content() {
  const { showBoundary } = useErrorBoundary()
  const { data: post, error } = usePostBySlug('confirm-payment')

  if (error) {
    toast.error(error?.message || 'Failed to fetch confirm payment page')
    showBoundary(error)
  }

  if (post) {
    document.title = post.meta.title

    const styleTag = document.getElementById('core-block-supports-inline-css')

    if (styleTag) {
      styleTag.innerHTML = post.styles
    } else {
      const style = document.createElement('style')
      style.id = 'core-block-supports-inline-css'
      document.head.appendChild(style)
      style.innerHTML = post.styles
    }
  }

  // get order id from query params name wcp_order_id
  const urlParams = new URLSearchParams(window.location.search)
  const orderId = urlParams.get('wcp_order_id')

  return (
    <div className="mx-auto my-10 max-w-screen-md">
      <h2 className="mb-6 text-2xl font-medium uppercase">Confirm Payment</h2>
      <ConfirmPaymentForm orderId={Number(orderId)} />
    </div>
  )
}

export function ConfirmPayment() {
  return (
    <ErrorBoundary>
      <Content />
    </ErrorBoundary>
  )
}

export default ConfirmPayment
